import {
  getLaboratorios,
  getLaboratorio,
  deleteLaboratorio,
  editLaboratorio,
  createLaboratorio,
} from "../../../helpers/backend_helper";
import {
  apiError,
  laboratoriosSuccess,
  laboratorioSuccess,
  laboratoriosDeleteSuccess,
  reset_laboratorio_flag,
} from "./reducer";

export const getLabs = () => async (dispatch) => {
  try {
    const response = getLaboratorios();
    const data = await response;

    if (data) {
      dispatch(laboratoriosSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const deleteLab = (id) => async (dispatch) => {
  try {
    const response = deleteLaboratorio(id);
    const data = await response;
    if (data) {
      dispatch(laboratoriosDeleteSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const editLab = (laboratorio) => async (dispatch) => {
  try {
    const response = editLaboratorio(laboratorio);
    const data = await response;
    if (data) {
      dispatch(laboratorioSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const createLab = (laboratorio) => async (dispatch) => {
  try {
    const response = createLaboratorio(laboratorio);
    const data = await response;  

    if (data) {
      dispatch(laboratorioSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const getLab = (id) => async (dispatch) => {
  try {
    const response = getLaboratorio(id);
    const data = await response;
    if (data) {
      dispatch(laboratorioSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLaboratorioFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_laboratorio_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
